export default __webpack_public_path__ + "static/humanitas-logo.3405c33d.svg";